import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Modal, Button } from 'react-bootstrap';
import { resetModel } from '../../../../store/components/modelSlice';
import { putActivityEnabled } from '../../../../services/dashboard/battery';
import { message } from 'antd';

const Ablemodal = () => {
    const [show, setShow] = useState(true);
    const dispatch = useDispatch();
    const content = useSelector((state) => state.model.data);

    const handleSubmit = () => {
        putActivityEnabled(content)
            .then(response => {
                cancelHandler();
                message.success('啟用成功');
                window.dispatchEvent(new Event('activityDataChanged')); 
            })
            .catch(error => {
                console.error('Error:', error);
                message.error('啟用失敗，請稍後再試');
            });
    };

    const cancelHandler = () => {
        setShow(false);
        dispatch(resetModel());
    };

    return (
        <Modal className='driver-model' show={show} onHide={cancelHandler} centered>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div style={{ color: 'red' }}>啟用注意事項如下：</div>
                <div className="message-left">
                    1. 啟用後，皆會回頭建立生效日/停用~啟用隔天這段期間，未被建立起來的車輛活動任務，活動起始日也會回寫<br/>
                    2. 若啟用的活動類型為 節慶任務 且該活動結束日已超過啟用時間，則隔天不會建立任何車輛活動任務（表示活動已結束）
                </div>
                <div className="button-container">
                    <Button variant="secondary" data-shadow onClick={cancelHandler}>關閉</Button>
                    <Button variant="primary" data-shadow onClick={handleSubmit}>確認</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default Ablemodal;